/*
 (c) 2016, Manuel Bär (www.geonet.ch)
 Leaflet.WindBarbs, a wind barb plugin for Leaflet.
 This plugin enables the automatic creation of 
 wind barb icons in Leaflet.
 version: 0.0.5
 */

/*global L*/

(function (window, document) {
  L.WindBarb = {};

  L.WindBarb.version = '0.0.1';

  L.WindBarb.Icon = L.Icon.extend({
    options: {
      fillColor: '#2B85C7',
      pointRadius: 8,
      strokeWidth: 2,
      strokeLength: 15,
      barbSpaceing: 5,
      barbHeight: 15,
      forceDir: false
    },

    initialize: function (options) {
      L.Util.setOptions(this, options);
    },

    createIcon: function () {
      let div = document.createElement('div');
      let svg = this._createPoint();
      div.appendChild(svg);
      this._setIconStyles(div);
      return div;
    },

    _createPoint: function () {
      const sw = this.options.strokeWidth;
      const r = this.options.pointRadius;
      const fc = this.options.fillColor;
      const w = 2 * sw + 2 * r;
      const h = w;
      const xmlns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(xmlns, 'svg');
      svg.setAttributeNS(null, 'width', w);
      svg.setAttributeNS(null, 'height', h);
      const c = document.createElementNS(xmlns, 'circle');
      c.setAttributeNS(null, 'stroke', '#010101');
      c.setAttributeNS(null, 'stroke-width', sw);
      c.setAttributeNS(null, 'fill', fc);
      c.setAttributeNS(null, 'cx', w / 2);
      c.setAttributeNS(null, 'cy', h / 2);
      c.setAttributeNS(null, 'r', r);
      svg.appendChild(c);
      return svg;
    },

    _createBarbs: function (speed) {
      const b = { 5: 0, 10: 0, 50: 0 };
      const bs = this.options.barbSpaceing;
      const bh = this.options.barbHeight;
      const r = this.options.pointRadius;
      const sw = this.options.strokeWidth;
      const sl = this.options.strokeLength;
      const fd = this.options.forceDir;
      const xmlns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(xmlns, 'svg');
      const g = document.createElementNS(xmlns, 'g');

      // Calculate number of each stroke and add path elements to svg group

      const s = (speed % 5) >= 2.5 ? parseInt(speed / 5, 10) * 5 + 5 : parseInt(speed / 5, 10) * 5;

      for (let i = s; i > 0;) {
        if (i - 50 >= 0) {
          b[50] += 1;
          i -= 50;
        } else if (i - 10 >= 0) {
          b[10] += 1;
          i -= 10;
        } else if (i - 5 >= 0) {
          b[5] += 1;
          i -= 5;
        } else {
          break;
        }
      }

      // Calculate height and Width of S

      const bn = b[5] + b[10] + b[50];
      let bw;
      if (bn === 0) {
        bw = 0;
      } else {
        bw = (bn * bs);
        if ((b[5] === 1 && b[10] > 0) || (b[5] === 1 && b[50] > 0)) {
          bw -= bs;
        }
        if (b[50] > 0) {
          bw += 3 * b[50] * bs;
        }
      }

      // calculate additional padding needed
      const p = Math.round(Math.sqrt(bh * bh + bw * bw)) + 2;

      // calculate width and height
      const w = r * 2 + sw * 2 + 2 * (bw + sl) + 2 * p;
      const h = w;

      // calculate center of circle
      const cx = w / 2;
      const cy = h / 2;

      svg.setAttributeNS(null, 'width', w);
      svg.setAttributeNS(null, 'height', h);
      svg.appendChild(g);

      let pt, px, py;
      if (fd === true || bn !== 0) {
        // set the x pointer
        px = cx - r - sw * 0.5;
        // set the y pointer
        py = cy;
        // set first M
        const M = px + ',' + py;
        // set first h
        const H = px - sl;
        // set the top x pointer
        pt = H - (2 * bs);

        // draw first line
        const path = document.createElementNS(xmlns, 'path');
        path.setAttributeNS(null, 'stroke', '#000000');
        path.setAttributeNS(null, 'stroke-width', sw);
        path.setAttributeNS(null, 'stroke-linecap', 'butt');
        path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
        g.appendChild(path);

        // update pointer
        px = H;
      }

      if (bn !== 0) {

        // Check if there is a 5kn barb
        if (b[5] === 1) {
          {
            // calculate length of 10kn barb
            const bl10 = Math.sqrt((2 * bs) * (2 * bs) + (bh * bh));
            // calculate angle of 10kn barb
            const ang10 = Math.atan(bh / (2 * bs));
            // calculate length of 5kn barb
            const bl5 = bl10 / 2;
            // get starting point of barb
            const M = (px) + ',' + py;
            // calculate x of 5kn barb using angle of 10kn barb
            let L = ((px) - (bl5 * Math.cos(ang10))) + ',' + (cy - bh * 0.5);

            const path = document.createElementNS(xmlns, 'path');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'stroke-linecap', 'butt');
            path.setAttributeNS(null, 'd', 'M ' + M + ' L ' + L);
            g.appendChild(path);
          }

          // if no other bars exist, draw little end line
          if (b[10] === 0 && b[50] === 0) {
            const M = (px) + ',' + py;
            px -= (bs);
            const H = px;
            const path = document.createElementNS(xmlns, 'path');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'stroke-linecap', 'butt');
            path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
            g.appendChild(path);
          }
        }

        for (let i = 0; i < b[10]; i++) {
          {
            const M = px + ',' + py;
            px -= bs;
            const H = px;

            const path = document.createElementNS(xmlns, 'path');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'stroke-linecap', 'butt');
            path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
            g.appendChild(path);
          }

          {
            const M = px + ',' + cy;
            pt -= bs;
            const L = pt + ',' + (cy - bh);

            const path = document.createElementNS(xmlns, 'path');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'stroke-linecap', 'butt');
            path.setAttributeNS(null, 'd', 'M ' + M + ' L ' + L);
            g.appendChild(path);
          }
        }

        if (b[50] > 0) {
          {
            const M = px + ',' + py;
            px -= bs;
            const H = px;

            const path = document.createElementNS(xmlns, 'path');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'stroke-linecap', 'butt');
            path.setAttributeNS(null, 'd', 'M ' + M + ' H ' + H);
            g.appendChild(path);
          }

          for (let i = 0; i < b[50]; i++) {
            pt -= bs;
            const p1 = px + ',' + cy;
            const p2 = pt + ',' + (cy - bh);
            const p3 = pt + ',' + cy;
            const path = document.createElementNS(xmlns, 'polygon');
            path.setAttributeNS(null, 'stroke', '#000000');
            path.setAttributeNS(null, 'stroke-width', sw);
            path.setAttributeNS(null, 'fill', '#000000');
            path.setAttributeNS(null, 'points', p1 + ' ' + p2 + ' ' + p3);
            g.appendChild(path);
            px -= 2 * bs;
            pt -= bs;
          }
        }
      }

      return { ax: cx, ay: cy, svg: svg };
    },

    _setIconStyles: function (img, name, a) {
      const size = L.point(this.options[name === 'shadow' ? 'shadowSize' : 'iconSize']);
      let anchor;

      if (name === 'shadow') {
        anchor = a;
        img.style.width = anchor.x + 'px';
        img.style.height = anchor.y + 'px';
      } else {
        img.style.position = 'absolute';
        const x = this.options.strokeWidth + this.options.pointRadius;
        const y = this.options.strokeWidth + this.options.pointRadius;
        anchor = L.point([x, y]);
      }

      if (!anchor && size) {
        anchor = size.divideBy(2, true);
      }

      if (anchor) {
        img.style.marginLeft = (-anchor.x) + 'px';
        img.style.marginTop = (-anchor.y) + 'px';
      }

      if (size) {
        img.style.width = size.x + 'px';
        img.style.height = size.y + 'px';
      }
    },

    createShadow: function () {
      const d = this.options.deg + 90;
      const s = this.options.speed;
      const b = this._createBarbs(s);
      const div = document.createElement('div');

      if (this.options.mirrorVel) {
        b.svg.style.transform = 'rotate(' + d + 'deg) scaleY(-1)';
        b.svg.style.MozTransform = 'rotate(' + d + 'deg) scaleY(-1)';
        b.svg.style.webkitTransform = 'rotate(' + d + 'deg) scaleY(-1)';
        b.svg.style.msTransform = 'rotate(' + d + 'deg) scaleY(-1)';
      } else {
        b.svg.style.transform = 'rotate(' + d + 'deg)';
        b.svg.style.MozTransform = 'rotate(' + d + 'deg)';
        b.svg.style.webkitTransform = 'rotate(' + d + 'deg)';
        b.svg.style.msTransform = 'rotate(' + d + 'deg)';
      }

      div.appendChild(b.svg);

      const anchor = { x: b['ax'], y: b['ay'] };
      this._setIconStyles(div, 'shadow', anchor);
      return div;
    }
  });

  L.WindBarb.icon = function (options) {
    return new L.WindBarb.Icon(options);
  };

}(this, document));



// WEBPACK FOOTER //
// ./src/components/leaflet/leaflet-windbar.js